/* The Brill logo (brand handoff, 2026-10-12): the sparkle mark, "brill" in
   Young Serif and the "by Tevra Wood" byline, all outlined in the SVGs in
   public/brand — no font to load. Every place the app shows the logo draws it
   from here, so the next logo change is one file.

   Sized by HEIGHT with width auto (the handoff's rule). The lockup has a
   120px minimum width — below it use the mark. `-dark` files sit on Indigo or
   Deep Navy (every screen that shows it today), `-light` on cream or white. */

const FILES = {
  lockup: { dark: "brill-lockup-dark", light: "brill-lockup-light" },
  wordmark: { dark: "brill-wordmark-softwhite", light: "brill-wordmark-indigo" },
  /* `white` is the one-colour mark — a dimmed tab icon, never the logo itself. */
  mark: { dark: "brill-mark-dark", light: "brill-mark-light", white: "brill-mark-white" },
};

export default function BrillLogo({ variant = "lockup", theme = "dark", height = 32, style }) {
  const set = FILES[variant] || FILES.lockup;
  const file = set[theme] || set.dark;
  return (
    <img src={`/brand/${file}.svg`} alt="Brill by Tevra Wood" height={height}
      style={{ height, width: "auto", display: "block", ...style }} />
  );
}
